import * as React from 'react'

function SvgIconAward(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="award" aria-labelledby="t-award d-award">
        <title id="t-award">{'Award'}</title>
        <desc id="d-award">{'Award'}</desc>
        <path d="M23 29a2 2 0 012 2H7a2 2 0 012-2h14m0-1H9c-1.654 0-3 1.346-3 3a1 1 0 001 1h18a1 1 0 001-1c0-1.654-1.346-3-3-3zM18 25c.549 0 1 .447 1 1s-.451 1-1 1h-4c-.554 0-1-.447-1-1s.446-1 1-1h4m0-1h-4c-1.103 0-2 .896-2 2s.897 2 2 2h4a2 2 0 000-4zM24 22.5a.502.502 0 01-.354-.146c-2.229-2.223-1.861-2.846 2-6.707 2.604-2.609 3.883-5.752 3.1-7.643C28.339 7.02 27.389 6.5 26 6.5a.5.5 0 010-1c1.8 0 3.104.753 3.67 2.121.949 2.291-.384 5.8-3.316 8.733-3.646 3.646-3.604 3.678-2 5.292A.5.5 0 0124 22.5z" />
        <path d="M24.5 0h-17a.5.5 0 00-.5.5c0 6.255.852 12.148 2.398 16.596C11.06 21.87 13.404 24 16 24s4.939-2.13 6.602-6.904C24.148 12.648 25 6.755 25 .5c0-.275-.225-.5-.5-.5zM16 23c-4.36 0-7.903-9.523-7.996-22h15.992C23.902 13.477 20.359 23 16 23z" />
        <path d="M8 22.5a.5.5 0 01-.354-.853c1.616-1.604 1.646-1.646-2-5.292-2.932-2.934-4.265-6.443-3.316-8.734C2.896 6.253 4.2 5.5 6 5.5a.5.5 0 010 1c-1.389 0-2.339.52-2.747 1.503-.783 1.892.492 5.034 3.1 7.643 3.862 3.861 4.223 4.484 2 6.708A.498.498 0 018 22.5z" />
      </g>
    </svg>
  )
}

export default SvgIconAward
